<template lang="html">
  <div class="col-12 tag-filters no-pad-both">

    <div class="filter-box-headline pointer" @click="$emit('close');">
      <h4>Filtre</h4>
      <span class="material-icons tag-filter-close-btn">close</span>
    </div>

    <h5 style="padding-left: 10px; font-size: 14px;">
      <strong>Vælg hvad du vil se på kort og lister:</strong>
    </h5>

    <span class="sr-only">Filtre for temaet's steder</span>

    <div class="filter-type noselect" id="filter-vehicle-type-options" v-show="activeFilters.indexOf('vehicleType') != -1">
      <div class="filter-headline" role="button" @click="showVehicleTypeFilters = !showVehicleTypeFilters">
        <span class="material-icons float-left" aria-hidden="true">accessible</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="showVehicleTypeFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showVehicleTypeFilters">keyboard_arrow_down</span>
        <strong>Køretøjstype</strong><br>Plads til bil eller handicapbus
      </div>
      <ul class="filter-type-options" v-show="showVehicleTypeFilters">
        <template v-for="(filter,index) in vehicleTypeFilters">
          <li class="filter-li" @click="toggleFilter(filter.option_id, filter.href, vehicleTypeFilters);">
            {{ filter.name }}
            <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
            <input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra">
          </li>
        </template>
      </ul>
    </div>

    <div class="filter-type noselect" id="filter-lift-options" v-show="activeFilters.indexOf('lift') != -1">
      <div class="filter-headline" role="button" @click="showLiftFilters = !showLiftFilters">
        <span class="material-icons float-left" aria-hidden="true">accessible</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="showLiftFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showLiftFilters">keyboard_arrow_down</span>
        <strong>Plads til lift</strong><br>Bagved, til højre og til venstre
      </div>
      <ul class="filter-type-options" v-show="showLiftFilters">
        <template v-for="(filter,index) in liftFilters">
          <li class="filter-li" @click="toggleFilter(filter.option_id, filter.href, liftFilters);">
            {{ filter.name }}
            <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
  					<input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra">
  				</li>
        </template>
      </ul>
    </div>

    <div class="filter-type noselect" id="filter-price-options" v-show="activeFilters.indexOf('price') != -1">
      <div class="filter-headline" role="button" @click="showPriceFilters = !showPriceFilters">
        <span class="material-icons float-left" aria-hidden="true">local_atm</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="showPriceFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showPriceFilters">keyboard_arrow_down</span>
        <strong>Priser</strong><br>Gratis parkering og max priser
      </div>
      <ul class="filter-type-options" v-show="showPriceFilters">
        <template v-for="(filter,index) in priceFilters">
          <li class="filter-li" @click="toggleFilter(filter.option_id, filter.href, priceFilters);">
            {{ filter.name }}
            <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
            <input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra">
          </li>
        </template>
      </ul>
    </div>

    <div class="filter-type noselect" id="filter-time-limit-options" v-show="activeFilters.indexOf('timeLimit') != -1">
      <div class="filter-headline" role="button" @click="showTimeLimitFilters = !showTimeLimitFilters">
        <span class="material-icons float-left" aria-hidden="true">access_time</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="showTimeLimitFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showTimeLimitFilters">keyboard_arrow_down</span>
        <strong>Tidsbegrænsninger</strong><br>Hvor længe kan du parkere
      </div>
      <ul class="filter-type-options" v-show="showTimeLimitFilters">
        <template v-for="(filter,index) in timeLimitFilters">
          <li class="filter-li" @click="toggleFilter(filter.option_id, filter.href, timeLimitFilters);">
            {{ filter.name }}
            <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
            <input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra">
          </li>
        </template>
      </ul>
    </div>

    <div class="filter-type noselect" id="filter-height-options" v-show="activeFilters.indexOf('clearanceHeight') != -1">
      <div class="filter-headline" role="button" @click="showHeightFilters = !showHeightFilters">
        <span class="material-icons rotate-left-90 float-left" aria-hidden="true">trending_flat</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="showHeightFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showHeightFilters">keyboard_arrow_down</span>
        <strong>Frihøjde</strong><br>Indstil minimumshøjde i cm
      </div>
      <ul class="filter-type-options row" v-show="showHeightFilters">
        <input type="text" class="form-control" id="clearance-height-value" placeholder="Frihøjde i cm" aria-label="Nødvendig frihøjde i cm" @keyup="changeClearanceHeight($event);">
      </ul>
    </div>

    <div class="filter-type noselect" id="filter-payment-options" v-show="activeFilters.indexOf('payment') != -1">
      <div class="filter-headline" role="button" @click="showPaymentFilters = !showPaymentFilters">
        <span class="material-icons float-left" aria-hidden="true">payment</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="showPaymentFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showPaymentFilters">keyboard_arrow_down</span>
        <strong>Betalingsmuligheder</strong><br>Mønter, kort, mobil med mere
      </div>
      <ul class="filter-type-options" v-show="showPaymentFilters">
        <li id="payment-all" @click="toggleAllPaymentOptions();">
          Tilvælg/fravælg alt
          <span class="material-icons float-right" aria-hidden="true" :class="[allPaymentOptionsEnabled ? 'blue-text' : 'grey-text']">check</span>
          <input type="checkbox" class="sr-only" :checked="allPaymentOptionsEnabled" aria-label="Slå alle betalingsmuligheder til eller fra">
        </li>
        <template v-for="(filter,index) in paymentOptionFilters">
          <li class="filter-li" @click="toggleFilter(filter.option_id, filter.href, paymentOptionFilters);">
            {{ filter.name }}
            <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
            <input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra">
          </li>
        </template>
      </ul>
    </div>

    <div class="filter-type noselect" id="filter-admin-options" v-show="activeFilters.indexOf('admin') != -1">
      <div class="filter-headline" role="button" @click="showAdminFilters = !showAdminFilters">
        <span class="material-icons float-left" aria-hidden="true">account_circle</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="showAdminFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showAdminFilters">keyboard_arrow_down</span>
        <strong>Administrator</strong><br>Parkeringspladsens administrator
      </div>
      <ul class="filter-type-options" v-show="showAdminFilters">
        <template v-for="(filter,index) in adminFilters">
          <li class="filter-li" @click="toggleFilter(filter.option_id, filter.href, adminFilters);">
            {{ filter.name }}
            <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
            <input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra">
          </li>
        </template>
      </ul>
    </div>

    <div class="filter-type noselect" id="filter-user-wish-type-options" v-show="activeFilters.indexOf('userWish') != -1">
      <div class="filter-headline" role="button" @click="showUserWishFilters = !showUserWishFilters">
        <img src="/img/customUseIcons/wish.svg" class="float-left" height="30" width="30" alt="Brugerønsker ikon" aria-hidden="true"/>
        <span class="material-icons float-right" aria-hidden="true" v-show="showUserWishFilters">keyboard_arrow_up</span>
        <span class="material-icons float-right" aria-hidden="true" v-show="!showUserWishFilters">keyboard_arrow_down</span>
        <strong>Type af brugerønske</strong><br>Bænk, belysning, handicapparkering m.v.
      </div>
      <ul class="filter-type-options" v-show="showUserWishFilters">
        <template v-for="(filter,index) in userWishFilters">
          <li class="filter-li" @click="toggleFilter(filter.option_id, filter.href, userWishFilters);">
            {{ filter.name }}
            <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
            <input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra">
          </li>
        </template>
      </ul>
    </div>

    <div class="col-12 filter-btn noselect" v-show="activeFilters.length > 2" @click="toggleAllFilters($event);">
      <div v-if="allFiltersShown">
        <span>Vis færre filtre</span>
        <span class="material-icons" aria-hidden="true">keyboard_arrow_up</span>
      </div>
      <div v-else>
        <span>Vis flere filtre</span>
        <span class="material-icons" aria-hidden="true">keyboard_arrow_down</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      activeFilters: [],
      vehicleTypeFilterIds: [],
      vehicleTypeFilters: [],
      liftFilterIds: [],
      liftFilters: [],
      priceFilters: [],
      timeLimitFilterIds: [],
      timeLimitFilters: [],
      paymentOptionFilterIds: [],
      paymentOptionFilters: [],
      adminFilterIds: [],
      adminFilters: [],
      userWishFilterIds: [],
      userWishFilters: [],
      showVehicleTypeFilters: false,
      showLiftFilters: false,
      showPriceFilters: false,
      showTimeLimitFilters: false,
      showHeightFilters: false,
      showPaymentFilters: false,
      showAdminFilters: false,
      showUserWishFilters: false,
      allPaymentOptionsEnabled: true,
      allFiltersShown: false,
    }
  },
  props: {
    tagData: {
      required: true,
    }
  },
  watch: {
    tagData() {
      this.resetFilters();
    },
  },
  methods: {
    resetFilters() {
      var elems = document.getElementsByClassName('filter-type');
      for(var i = 0; i < elems.length; i++) {
        elems[i].classList.remove('hide-on-toggle', 'hidden');
      }
      this.allFiltersShown = false;
      this.activeFilters = [];
      this.vehicleTypeFilterIds = [];
      this.vehicleTypeFilters = [];
      this.liftFilterIds = [];
      this.liftFilters = [];
      this.priceFilters = [];
      this.timeLimitFilterIds = [];
      this.timeLimitFilters = [];
      this.paymentOptionFilterIds = [];
      this.paymentOptionFilters = [];
      this.adminFilterIds = [];
      this.adminFilters = [];
      this.userWishFilterIds = [];
      this.userWishFilters = [];
      this.generateFilters();
    },
  	generateFilters() {
  		var numberOfFilters = 0;

  		for(var i = 0; i < this.$props.tagData.features.length; i++) {
        for(var k in this.$props.tagData.features[i].properties) {
          if(this.$props.tagData.features[i].properties[k].id == 106) {
            var typeFilter = this.$props.tagData.features[i].properties[k];
          }
          if(this.$props.tagData.features[i].properties[k].id == 64) {
            var liftFilter = this.$props.tagData.features[i].properties[k];
          }
          if(this.$props.tagData.features[i].properties[k].id == 49) {
            var priceFilter = this.$props.tagData.features[i].properties[k];
          }
          if(this.$props.tagData.features[i].properties[k].id == 50) {
            var timeLimitFilter = this.$props.tagData.features[i].properties[k];
          }
          if(this.$props.tagData.features[i].properties[k].id == 65) {
            var clearanceHeightFilter = this.$props.tagData.features[i].properties[k];
          }
          if(this.$props.tagData.features[i].properties[k].id == 99) {
            var paymentOptionFilter = this.$props.tagData.features[i].properties[k];
          }
          if(this.$props.tagData.features[i].properties[k].id == 54) {
            var adminFilter = this.$props.tagData.features[i].properties[k];
          }
          if(this.$props.tagData.features[i].properties[k].id == 120) {
            var userWishFilter = this.$props.tagData.features[i].properties[k];
          }
        }
        //Vehicle type filters
  			if(typeFilter != undefined) {
          if(this.activeFilters.indexOf('vehicleType') == -1) {
  					this.activeFilters.push('vehicleType');
            (numberOfFilters >= 2) ? document.getElementById('filter-vehicle-type-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
  				}
  				if(this.vehicleTypeFilterIds.indexOf(typeFilter.option_id) == -1) {
  					this.vehicleTypeFilterIds.push(typeFilter.option_id);
            let dataHref = 'OdenseRundt-FilterOption-vehicle-type-'+typeFilter.option_id;
            let options = {checked: false, href: dataHref, option_id: typeFilter.option_id, name: typeFilter.value};
  					if(localStorage.getItem(dataHref) == undefined) {
  						localStorage.setItem(dataHref, 'true');
  					}
          	options.checked = (localStorage.getItem(dataHref) == 'false') ? false : true;
            this.vehicleTypeFilters.push(options);
  				}
  			}
  			//Room for handicap lift filters
  			if(liftFilter != undefined && this.activeFilters.indexOf('lift') == -1) {
  				this.activeFilters.push('lift');
          (numberOfFilters >= 2) ? document.getElementById('filter-lift-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
  				for(var j = 0; j < liftFilter.value.length; j++) {
  					var machineString = liftFilter.value[j].name.replace('ø', 'o').replace(/ /g, '');
            this.liftFilterIds.push(machineString);
            let dataHref = 'OdenseRundt-FilterOption-lift-'+machineString;
            let options = {checked: false, href: dataHref, option_id: machineString, name: liftFilter.value[j].name};
  					if(localStorage.getItem(dataHref) == undefined) {
  						localStorage.setItem(dataHref, 'true');
  					}
            options.checked = (localStorage.getItem(dataHref) == 'false') ? false : true;
            this.liftFilters.push(options);
  				}
  			}
  			//Price filters
  			if(priceFilter != undefined && this.activeFilters.indexOf('price') == -1) {
          //console.log(this.activeFilters);
          this.activeFilters.push('price');
          (numberOfFilters >= 2) ? document.getElementById('filter-price-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
          var data = [
            {name: 'Gratis', href: 'OdenseRundt-FilterOption-price-0', option_id: 'price-0'},
            {name: 'Max 12 kr/time', href: 'OdenseRundt-FilterOption-price-max-12', option_id: 'price-max-12'},
            {name: 'Over 12 kr/time', href: 'OdenseRundt-FilterOption-price-above-12', option_id: 'price-above-12'},
            {name: 'Ingen info om pris', href: 'OdenseRundt-FilterOption-price-no-info', option_id: 'price-no-info'},
          ];
          for(var j = 0; j < data.length; j++) {
            if(localStorage.getItem(data[j].href) == undefined) {
    					localStorage.setItem(data[j].href, 'true');
    				}
    				let options = {checked: false, href: data[j].href, option_id: data[j].option_id, name: data[j].name};
            options.checked = (localStorage.getItem(data[j].href) == 'true') ? true : false;
            this.priceFilters.push(options);
          }
  			}
  			//Time limit filters
  			if(timeLimitFilter != undefined) {
          if(this.activeFilters.indexOf('timeLimit') == -1) {
  					this.activeFilters.push('timeLimit');
            (numberOfFilters >= 2) ? document.getElementById('filter-time-limit-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
  				}
  				if(this.timeLimitFilterIds.indexOf(timeLimitFilter.option_id) == -1) {
  					this.timeLimitFilterIds.push(timeLimitFilter.option_id);
  				}
  			}
  			//Clearance height filters
  			if(clearanceHeightFilter != undefined && this.activeFilters.indexOf('clearanceHeight') == -1) {
  				this.activeFilters.push('clearanceHeight');
          (numberOfFilters >= 2) ? document.getElementById('filter-height-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
  				var clearanceHeightValue = localStorage.getItem('OdenseRundt-FilterOption-clearance-height-value');
  				if(clearanceHeightValue == undefined) {
  					clearanceHeightValue = 0;
  					localStorage.setItem('OdenseRundt-FilterOption-clearance-height-value', '0');
  				}
  				document.getElementById('clearance-height-value').value = clearanceHeightValue;
  			}
  			//Payment options filter
  			if(paymentOptionFilter != undefined) {
          if(this.activeFilters.indexOf('payment') == -1) {
  					this.activeFilters.push('payment');
            (numberOfFilters >= 2) ? document.getElementById('filter-payment-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
  				}
  				for(var j = 0; j < paymentOptionFilter.value.length; j++) {
  					if(this.paymentOptionFilterIds.indexOf(paymentOptionFilter.value[j].id) == -1) {
  						this.paymentOptionFilterIds.push(paymentOptionFilter.value[j].id);
  					}
  				}
  			}
  			//Admin filters
  			if(adminFilter != undefined) {
          if(this.activeFilters.indexOf('admin') == -1) {
  					this.activeFilters.push('admin');
            (numberOfFilters >= 2) ? document.getElementById('filter-admin-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
          }
  				if(this.adminFilterIds.indexOf(adminFilter.option_id) == -1) {
  					this.adminFilterIds.push(adminFilter.option_id);
            let dataHref = 'OdenseRundt-FilterOption-admin-'+adminFilter.option_id;
            var options = {checked: false, href: dataHref, option_id: adminFilter.option_id, name: adminFilter.value};
  					if(localStorage.getItem(dataHref) == undefined) {
  						localStorage.setItem(dataHref, 'true');
  					}
  					options.checked = (localStorage.getItem(dataHref) == 'false') ? false : true;
            this.adminFilters.push(options);
  				}
				}
  			//User wish type filters
  			if(userWishFilter != undefined) {
          if(this.activeFilters.indexOf('userWish') == -1) {
  					this.activeFilters.push('userWish');
            (numberOfFilters >= 2) ? document.getElementById('filter-user-wish-type-options').classList.add('hide-on-toggle', 'hidden') : numberOfFilters++;
  				}
  				if(this.userWishFilterIds.indexOf(userWishFilter.option_id) == -1) {
  					this.userWishFilterIds.push(userWishFilter.option_id);
            let dataHref = 'OdenseRundt-FilterOption-userWishType-'+userWishFilter.option_id;
            var options = {checked: false, href: dataHref, option_id: userWishFilter.option_id, name: userWishFilter.value};
  					if(localStorage.getItem(dataHref) == undefined) {
  						localStorage.setItem(dataHref, 'true');
  					}
            options.checked = (localStorage.getItem(dataHref) == 'false') ? false : true;
            this.userWishFilters.push(options);
  				}
  			}
  		}
      //Insert time limit filters in the correct order according to content manager
  		if(this.timeLimitFilterIds.length != 0) {
        axios.get('https://apps.odenserundt.dk/data/parkering/time_limit_order.php')
    	  .then(response => {
          var timeLimitOrder = response.data;
          for(var j = 0; j < timeLimitOrder.length; j++) {
    				var compareInt = parseInt(timeLimitOrder[j].id);
    				if(this.timeLimitFilterIds.indexOf(compareInt) != -1) {
              let dataHref = 'OdenseRundt-FilterOption-time-limit-'+timeLimitOrder[j].id;
              let options = {checked: false, href: dataHref, option_id: timeLimitOrder[j].id, name: timeLimitOrder[j].option};
    					if(localStorage.getItem(dataHref) == undefined) {
    						localStorage.setItem(dataHref, 'true');
    					}
              options.checked = (localStorage.getItem(dataHref) == 'false') ? false : true;
              this.timeLimitFilters.push(options);
    				}
    			}
    	  })
    	  .catch(function (error) {
    	    console.log('Error getting time limit order', error);
    	  });
  		}
  		//Insert payment option filters in the correct order according to content manager
  		if(this.paymentOptionFilterIds.length != 0) {
        axios.get('https://apps.odenserundt.dk/data/parkering/payment_order.php')
    	  .then(response => {
          var paymentOrder = response.data;
          var allToggled = localStorage.getItem('OdenseRundt-FilterOption-payment-select-all');
          if(allToggled == undefined || allToggled == 'true') {
    				localStorage.setItem('OdenseRundt-FilterOption-payment-select-all', 'true');
            this.allPaymentOptionsEnabled = true;
    			}
          else {
            this.allPaymentOptionsEnabled = false;
          }

    			for(var j = 0; j < paymentOrder.length; j++) {
    				var compareInt = parseInt(paymentOrder[j].id);
    				if(this.paymentOptionFilterIds.indexOf(compareInt) != -1) {
              let dataHref = 'OdenseRundt-FilterOption-payment-'+paymentOrder[j].id;
              let options = {checked: false, href: dataHref, option_id: paymentOrder[j].id, name: paymentOrder[j].name};
    					if(localStorage.getItem(dataHref) == undefined) {
    						localStorage.setItem(dataHref, 'true');
    					}
              options.checked = (localStorage.getItem(dataHref) == 'false') ? false : true;
              this.paymentOptionFilters.push(options);
    				}
    			}
    	  })
    	  .catch(function (error) {
    	    console.log('Error getting payment order', error);
    	  });
      }
  		//console.log(this.activeFilters);
  		/*console.log(this.timeLimitFilters);
  		console.log(this.paymentFilters);
  		console.log(this.adminFilters);*/
  		//this.filterPlaces();
  	},
    toggleFilter(targetId, href, filterArray) {
      //console.log(filterArray);
      //console.log(targetId);
      for(var i = 0; i < filterArray.length; i++) {
        if(filterArray[i].option_id == targetId) {
          //console.log(filterArray[i]);
    			if(localStorage.getItem(href) == 'true' || localStorage.getItem(href) == null) {
            //console.log('true/null before click');
    				localStorage.setItem(href, 'false');
            filterArray[i].checked = false;
    			}
    			else {
            //console.log('false before click');
    				localStorage.setItem(href, 'true');
            filterArray[i].checked = true;
    			}
        }
      }
			this.filterPlaces();
  	},
  	//Select / deselect all payment options
  	toggleAllPaymentOptions() {
      this.allPaymentOptionsEnabled = !this.allPaymentOptionsEnabled;
      localStorage.setItem('OdenseRundt-FilterOption-payment-select-all', this.allPaymentOptionsEnabled);

      for(var i in this.paymentOptionFilters) {
        this.paymentOptionFilters[i].checked = this.allPaymentOptionsEnabled;
        localStorage.setItem(this.paymentOptionFilters[i].href, this.allPaymentOptionsEnabled);
      }
  		this.filterPlaces();
  	},

  	changeClearanceHeight: function(e) {
  		localStorage.setItem('OdenseRundt-FilterOption-clearance-height-value', e.currentTarget.value);
  		this.filterPlaces();
  	},

    //Show/hide all filters
  	toggleAllFilters(e) {
      this.allFiltersShown = !this.allFiltersShown;
      var elems = document.getElementsByClassName('hide-on-toggle');
      for(var i = 0; i < elems.length; i++) {
        elems[i].classList.toggle('hidden');
      }
  	},

    filterPlaces() {
  		this.$root.$emit('toggleLoadingScreen', true);
  		var tagDataFiltered = [];
  		var tagDataDiscarded = [];
  		for(var i = 0; i < this.tagData.features.length; i++) {
  			var checkPassed = [];
  			for(var a = 0; a < this.activeFilters.length; a++) {
  				checkPassed[a] = this.checkFilterController(this.activeFilters[a], this.tagData.features[i]);
  			}
        //console.log(this.tagData.features[i].name);
  			if(checkPassed.indexOf(false) === -1) {
          //console.log(true);
  				tagDataFiltered.push(this.tagData.features[i]);
  			}
  			else {
          //console.log(false);
  				tagDataDiscarded.push(this.tagData.features[i]);
  			}
  		}
  		/*console.log('Filtered:', tagDataFiltered);
      console.log('Discarded:', tagDataDiscarded);*/
      this.$emit('dataFiltered', tagDataFiltered)
      setTimeout(() => {
        this.$root.$emit('toggleLoadingScreen', false);
      }, 500);
  	},
    //Filter controller
  	checkFilterController(filter, feature) {
  		var result;
  		switch(filter) {
  			case 'price':
  				result = this.checkPrice(feature);
  				break;
  			case 'timeLimit':
  				result = this.checkTimeLimit(feature);
  				break;
  			case 'clearanceHeight':
  				result = this.checkMaxHeight(feature);
  				break;
  			case 'payment':
  				result = this.checkPaymentOptions(feature);
  				break;
  			case 'admin':
  				result = this.checkAdmin(feature);
  				break;
  			case 'lift':
  				result = this.checkLift(feature);
  				break;
  			case 'vehicleType':
  				result = this.checkVehicleType(feature);
  				break;
  			case 'userWish':
  				result = this.checkUserWishType(feature);
  				break;
  		}
  		return result;
  	},

  	checkPrice(feature) {
  		if(feature.properties.prop49) {
  			if(feature.properties.prop49.value.length > 5) {
  				return true;
  			}
  			else {
  				if(localStorage.getItem('OdenseRundt-FilterOption-price-0') == 'true' && parseInt(feature.properties.prop49.value) == 0) {
  					return true;
  				}
  				else if(localStorage.getItem('OdenseRundt-FilterOption-price-0') == 'false' && parseInt(feature.properties.prop49.value) == 0) {
  					//console.log(feature.name+': Gratis');
  					return false;
  				}
  				else {
  					if(localStorage.getItem('OdenseRundt-FilterOption-price-max-12') == 'true' && parseInt(feature.properties.prop49.value) <= 12 && parseInt(feature.properties.prop49.value) != 0) {
  						return true;
  					}
  					if(localStorage.getItem('OdenseRundt-FilterOption-price-above-12') == 'true' && parseInt(feature.properties.prop49.value) > 12) {
  						return true;
  					}
  					if(localStorage.getItem('OdenseRundt-FilterOption-price-no-info') == 'true' && feature.properties.prop49.value == 'Ingen info') {
  						return true;
  					}
  					else {
  						//console.log(feature.name+': Ikke gratis');
  						return false;
  					}
  				}
  			}
  		}
  		return false;
  	},

  	checkTimeLimit(feature) {
  		if(feature.properties.prop50) {
  			for(var i = 0; i < this.timeLimitFilterIds.length; i++) {
  				if(localStorage.getItem('OdenseRundt-FilterOption-time-limit-'+this.timeLimitFilterIds[i]) == 'true' && (feature.properties.prop50.option_id) == this.timeLimitFilterIds[i]) {
  					//console.log('Gokendt');
  					return true;
  				}
  			}
  			//console.log('Afvist');
  			return false;
  		}
  		//console.log(feature.name, feature.id, 'Afvist: Mangler property Tidsbegrænsning');
  		return false;
  	},

  	checkMaxHeight(feature) {
  		if(feature.properties.prop65) {
  			var heightConverted = feature.properties.prop65.value * 100;
  			if(localStorage.getItem('OdenseRundt-FilterOption-clearance-height-value') > heightConverted) {
  				return false;
  			}
  			else {
  				return true;
  			}
  		}
  		else {
  			return true;
  		}
  	},

  	checkPaymentOptions(feature) {
  		if(feature.properties.prop99) {
  			for(var i = 0; i < this.paymentOptionFilterIds.length; i++) {
  				if(localStorage.getItem('OdenseRundt-FilterOption-payment-'+this.paymentOptionFilterIds[i]) == 'true') {
            var paymentOption = feature.properties.prop99.value.find(obj => obj.id == this.paymentOptionFilterIds[i]);
  					if(paymentOption != undefined && paymentOption.pay == true) {
  						//console.log('Gokendt');
  						return true;
  					}
  				}
  			}
  			//console.log(feature.name, 'Afvist - Betalingsmuligheder');
  			return false;
  		}
  		if(feature.properties.prop49) {
  			if(parseInt(feature.properties.prop49.value) != 0) {
  				//console.log(feature.name, 'Mangler property betalingsmuligheder');
  			}
  		}
  		return true;
  	},

  	checkAdmin(feature) {
  		if(feature.properties.prop54) {
  			for(var i = 0; i < this.adminFilterIds.length; i++) {
  				if(localStorage.getItem('OdenseRundt-FilterOption-admin-'+this.adminFilterIds[i]) == 'true' && (feature.properties.prop54.option_id) == this.adminFilterIds[i]) {
  					//console.log('Gokendt');
  					return true;
  				}
  			}
  			//console.log(feature.name, 'Afvist - Admin');
  			return false;
  		}
  		//console.log(feature.name, feature.id, 'Afvist: Mangler property Admin');
  		return false;
  	},

  	checkLift(feature) {
  		if(feature.properties.prop64) {
  			for(var i = 0; i < this.liftFilterIds.length; i++) {
  				var machineString = feature.properties.prop64.value[i].name.replace('ø', 'o').replace(/ /g, '');
  				if(localStorage.getItem('OdenseRundt-FilterOption-lift-'+this.liftFilterIds[i]) == 'true' && (feature.properties.prop64.value[i].value) == true) {
  					//console.log('Gokendt');
  					return true;
  				}
  			}
  			//console.log(feature.name, 'Afvist - Lift');
  			return false;
  		}
  		console.log(feature.name, feature.id, 'Afvist: Mangler property Lift');
  		return false;
  	},

  	checkVehicleType(feature) {
  		if(feature.properties.prop106) {
  			for(var i = 0; i < this.vehicleTypeFilterIds.length; i++) {
  				if(localStorage.getItem('OdenseRundt-FilterOption-vehicle-type-'+this.vehicleTypeFilterIds[i]) == 'true' && (feature.properties.prop106.option_id) == this.vehicleTypeFilterIds[i]) {
  					//console.log('Gokendt');
  					return true;
  				}
  			}
  			//console.log(feature.name, 'Afvist - Køretøjstype');
  			return false;
  		}
  		console.log(feature.name, feature.id, 'Afvist: Mangler property Køretøjstype');
  		return false;
  	},

  	checkUserWishType(feature) {
  		if(feature.properties.prop120) {
  			for(var i = 0; i < this.userWishFilterIds.length; i++) {
  				if(localStorage.getItem('OdenseRundt-FilterOption-userWishType-'+this.userWishFilterIds[i]) == 'true' && (feature.properties.prop120.option_id) == this.userWishFilterIds[i]) {
  					//console.log('Gokendt');
  					return true;
  				}
  			}
  			//console.log(feature.name, ': Afvist - Brugerønsketype');
  			return false;
  		}
  		console.log(feature.name, feature.id, 'Afvist: Mangler property Brugerønsketype');
  		return false;
  	},
  },
}
</script>

<style lang="css" scoped>
  .tag-filters {
    margin-top: 10px;
    margin-bottom: 10px;
    /*background-color: #f8f8f8;*/
    background-color: #fdfdfd;
  }

  h5 {
    font-size: 14px;
    padding: 10px;
    margin: 0px;
  }

  .tag-filters.filter-fullscreen {
  	position: fixed;
    z-index: 990;
    left: 0px;
    bottom: -200px;
    margin-bottom: 0px;
    max-height: 200px;
    overflow-y: auto;
    border-top: 1px solid #ddd;
  	border-bottom: none;
  	-webkit-transition: 1.2s ease;
  	-moz-transition: 1.2s ease;
  	-o-transition: 1.2s ease;
  	-ms-transition: 1.2s ease;
  	transition: 1.2s ease;
  }

  .tag-filters.filter-fullscreen.show-filters {
  	bottom: 0px !important;
  }

  .filter-box-headline {
  	display: none;
  	text-align: center;
  }

  .filter-box-headline h4, .filter-box-headline .material-icons {
  	display: inline-block;
  }

  .tag-filter-close-btn {
  	position: absolute;
  	right: 5px;
  	top: 5px;
  }

  .tag-filters.filter-fullscreen .filter-box-headline {
  	display: block;
  }

  .filter-btn {
  	height: 30px;
  	border-top: 1px solid #ddd;
    padding: 0px 5px 0px 5px;
  	text-align: center;
    cursor: pointer;
  }

  .filter-btn .material-icons {
  	vertical-align: middle;
  }

  @media screen and (orientation: portrait) {
  	.tag-filters {
  		border-bottom: 1px solid #ddd;
  	}
  }

  @media screen and (max-width: 767px) and (orientation: landscape) {
  	.tag-filters {
  		margin-top: 10px;
  		border-bottom: 1px solid #ddd;
  	}
  }

  @media screen and (min-width: 768px) and (orientation: landscape) {
  	.tag-filters {
  		margin-top: 0px;
  		border: 1px solid #ddd;
  		border-top: none;
  	}
  }

  .filter-type {
  	border-top: 1px solid #ddd;
  	padding: 10px;
    cursor: pointer;
  }

  .filter-headline .material-icons {
  	position: relative;
  	top: 5px;
  	margin-right: 10px;
  }

  .filter-type-options {
  	margin: 10px 0px 0px 10px;
  }

  .filter-type-options li {
  	height: 30px;
  	line-height: 30px;
  	padding-left: 30px;
  	padding-right: 10px;
  	vertical-align: middle;
  	cursor: pointer;
  }

  #payment-all {
  	font-weight: bold;
  }

  #clearance-height-value {
  	margin-left: 30px;
  	width: 100px;
  }
</style>
